import { useEffect } from 'react'
import { useLocation, useParams } from 'react-router-dom'
import { AppDispatch } from 'src/utils/AppDispatch'
import { useDispatch } from 'react-redux'
import { updateApplicationInterest } from 'src/redux/slices/Application/Action'
import { applicationSlice } from 'src/redux/slices/Application'
import { AlertSlice } from 'src/redux/slices/Alert'
import FlatsyTheme from '@flatsy/core/MuiTheme/flatsyTheme'
import { useApplicationDetails } from 'src/hooks/ApplicationDetails'

const useQuery = () => new URLSearchParams(useLocation().search)

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const useApplicationInterest = () => {
  const { applicationId } = useParams<{ applicationId: string }>()
  const queryString = useQuery()
  const getIsInterest = queryString.get('interest')
  const isInterest = getIsInterest === 'true'
  const dispatch: AppDispatch = useDispatch()
  const applicationDetails = useApplicationDetails().application

  const dispatchPostInterest = () => {
    dispatch(
      AlertSlice.actions.setAlert({
        severity: 'info',
        content: 'Votre intérêt a été transmis à l’agence',
        open: true,
        icon: <img src={FlatsyTheme.image.iconTask} alt="icon-checkmark-green" />,
      })
    )
  }

  useEffect(() => {
    if (isInterest) {
      dispatch(
        updateApplicationInterest({
          applicationId,
          interest: isInterest,
        })
      )
        .then(() => dispatch(applicationSlice.actions.setPostBookingInterestFromMailToTrue()))
        .catch(() => {
          // empty
        })
    }
  }, [applicationId])

  useEffect(() => {
    if (applicationDetails.postBookingInterestFromMail) {
      dispatchPostInterest()
      dispatch(applicationSlice.actions.setPostBookingInterestFromMailToFalse())
    }
  }, [applicationDetails.postBookingInterestFromMail])
}
